import { PublicHeader } from "../../Components/Public/WelcomePage/Header/PublicHeader";
import { AboutUs } from "../../Components/Public/WelcomePage/AboutUs/AboutUs";
import { Footer } from "../../Components/Public/WelcomePage/Footer/Footer";
// import { MobileApp } from "../../Components/Public/WelcomePage/MobileApp/MobileApp";

export const WelcomePage = () => {
  return (
    <>
      <PublicHeader />
      <AboutUs />
      {/* <MobileApp /> */}
      <Footer />
    </>
  );
};
